import { render, staticRenderFns } from "./order4.vue?vue&type=template&id=16fd202e&scoped=true"
import script from "./order4.vue?vue&type=script&lang=js"
export * from "./order4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd202e",
  null
  
)

export default component.exports